<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">

          <div class="col-12">
        
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Daftar Adjustment</h3>

                <div class="card-tools">
                  
                  <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                      <i class="fa fa-plus-square"></i>
                      Tambah Adjustment
                  </button>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <!--th>ID</th-->
                      <th>Tanggal</th>
                      <th>Sumber Dana</th>
                      <th>Barang</th>
                      <th>Qty</th>
                      <th>Satuan</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                     <tr v-for="adjustment in adjustments.data" :key="adjustment.id">

                      <!--td>{{adjustment.id}}</td-->
                      <td class="text-capitalize">{{adjustment.tanggal}}</td>
                      <td>{{adjustment.sumber_dana}}</td>
                      <td>{{adjustment.barang}}</td>
                      <td>{{adjustment.qty}}</td>
                      <td>{{adjustment.satuan}}</td>
                      <td>

                        <a href="#" @click="editModal(adjustment)">
                            <i class="fa fa-edit blue"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                  <pagination :data="adjustments" @pagination-change-page="getResults"></pagination>
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">Tambah Adjustment</h5>
                    <h5 class="modal-title" v-show="editmode">Ubah Adjustment</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- <form @submit.prevent="createUser"> -->

                <form @submit.prevent="editmode ? updateAdjustment() : createAdjustment()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Tanggal</label>
                            <datepicker v-model="form.tanggal" name="tanggal" :class="{ 'is-invalid': form.errors.has('tanggal') }" format="yyyy-MM-dd"></datepicker>
                            <has-error :form="form" field="tanggal"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Sumber Dana</label>                            
                            <select v-model="form.sumber_dana_id" name="sumber_dana_id" class="form-control" :class="{ 'is-invalid': form.errors.has('unit_kerja_id') }">
                            <option v-for="sumberdana in sumberdanas" v-bind:value="sumberdana.id">
                                {{ sumberdana.nama }}
                            </option>

                            </select>
                            <has-error :form="form" field="sumber_dana_id"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Barang</label>
                            <select v-model="form.barang_id" name="barang_id" class="form-control" :class="{ 'is-invalid': form.errors.has('barang_id') }">
                            <option v-for="barang in barangs" v-bind:value="barang.id">
                                {{ barang.nama_barang }} ( {{ barang.satuan.nama }} )
                            </option>

                            </select>
                            <has-error :form="form" field="barang_id"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Qty</label>
                            <input v-model="form.qty" type="number" name="qty"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('qty') }">
                            <has-error :form="form" field="qty"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Keterangan</label>
                            <input v-model="form.keterangan" type="text" name="keterangan"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('keterangan') }">
                            <has-error :form="form" field="keterangan"></has-error>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button v-show="editmode" type="submit" class="btn btn-success">Simpan</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">Simpan</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    export default {
        data () {
            return {
                editmode: false,
                adjustments : {},
                unitkerjas : {},
                sumberdanas : {},
                barangs : {},
                form: new Form({
                    id : '',      
                    nama: '',
                    unit_kerja_id: '',
                })
            }
        },
        methods: {

            getResults(page = 1) {

                  this.$Progress.start();
                  
                  axios.get('/api/adjustment?page=' + page).then(({ data }) => (this.adjustments = data.adjustment.data));

                  this.$Progress.finish();
            },
            updateAdjustment(){
                this.$Progress.start();
                this.form.put('/api/adjustment/'+this.form.id)
                .then((response) => {
                    // success
                    $('#addNew').modal('hide');
                    Toast.fire({
                      icon: 'success',
                      title: response.data.message
                    });
                    this.$Progress.finish();
                        //  Fire.$emit('AfterCreate');

                    this.loadAdjustments();
                })
                .catch(() => {
                    this.$Progress.fail();
                });

            },
            editModal(adjustment){
                this.editmode = true;
                this.form.reset();
                $('#addNew').modal('show');
                this.form.fill(adjustment);
            },
            newModal(){
                this.editmode = false;
                this.form.reset();
                $('#addNew').modal('show');
            },

            loadAdjustments(){
                    axios.get("/api/adjustment").then(({ data }) => (this.adjustments = data.data.adjustment, this.unitkerjas = data.data.unit_kerja, this.sumberdanas = data.data.sumber_dana, this.barangs = data.data.barang));
            },
            
            createAdjustment(){

                this.form.post('/api/adjustment')
                .then((response)=>{
                    $('#addNew').modal('hide');

                    Toast.fire({
                            icon: 'success',
                            title: response.data.message
                    });

                    this.$Progress.finish();
                    this.loadAdjustments();
                })
                .catch(()=>{
                    Toast.fire({
                        icon: 'error',
                        title: 'Some error occured! Please try again'
                    });
                })
            }

        },
        mounted() {
            console.log('Component mounted.')
        },
        created() {
            this.$Progress.start();
            this.loadAdjustments();
            this.$Progress.finish();

        },
        components: {
            Datepicker
        }
    }
</script>